import { motion } from "framer-motion";
import { MousePointerClick, ShieldCheck, MailCheck } from "lucide-react";
import SectionHeading from "./SectionHeading";

const STEPS = [
    {
        icon: MousePointerClick,
        title: "Click Buy Now",
        text: "Choose the ₹199 bundle and tap the button — no account needed.",
    },
    {
        icon: ShieldCheck,
        title: "Pay Securely",
        text: "UPI, cards or netbanking through a 100% protected checkout.",
    },
    {
        icon: MailCheck,
        title: "Get Instant Access",
        text: "Your download link arrives on email & WhatsApp within minutes.",
    },
];

export default function HowItWorks() {
    return (
        <section
            data-testid="how-it-works-section"
            className="py-16 sm:py-24"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <SectionHeading
                    eyebrow="How it works"
                    title="From payment to reading in 3 steps"
                />
                <div className="relative mt-12 grid gap-6 md:grid-cols-3">
                    <div
                        aria-hidden="true"
                        className="absolute left-[16%] right-[16%] top-10 hidden border-t-2 border-dashed border-emerald-200 md:block"
                    />
                    {STEPS.map(({ icon: Icon, title, text }, i) => (
                        <motion.div
                            key={title}
                            initial={{ opacity: 0, y: 24 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{ duration: 0.55, delay: i * 0.12 }}
                            className="relative rounded-2xl border border-emerald-100 bg-white p-6 text-center shadow-soft sm:p-8"
                            data-testid="how-it-works-step"
                        >
                            <span className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-emerald-600 text-white shadow-lg shadow-emerald-600/25">
                                <Icon size={26} />
                                <span className="absolute -right-2 -top-2 flex h-7 w-7 items-center justify-center rounded-full bg-amber-400 font-display text-xs font-extrabold text-slate-900">
                                    {i + 1}
                                </span>
                            </span>
                            <h3 className="mt-5 font-display text-lg font-bold text-slate-900">
                                {title}
                            </h3>
                            <p className="mt-2 text-sm leading-relaxed text-slate-600">
                                {text}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
